// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"8cbcfa31","477":"06e2e5ad"}[chunkId] + ".chunk.js";
};